import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useState } from 'react';

import { activeOrgName, orgLogoUrl, type Me } from '../lib/me';

/** The business's logo and name, in front of the top bar links. */
export function OrgIdentity({ me }: { me: Me }) {
  const url = orgLogoUrl(me);
  // If an image can't load, the name is still there. Remembered per logo, so a new one gets a try.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        minWidth: 0,
        minHeight: 56,
        // On a phone it shares its row with the initials, and gives way to them.
        flex: '1 1 0',
        // A quiet line between who this is and where you can go.
        [theme.breakpoints.up('md')]: {
          flex: '0 1 auto',
          pr: 2,
          my: 1.5,
          minHeight: 0,
          borderRight: `1px solid ${alpha(theme.palette.common.white, 0.3)}`,
        },
      })}
    >
      {url && url !== failedUrl && (
        // A pale backing keeps a dark logo visible on the dark bar.
        <Box
          component="img"
          src={url}
          alt=""
          onError={() => setFailedUrl(url)}
          sx={{
            height: 32,
            maxWidth: { xs: 96, lg: 120 },
            flexShrink: 0,
            p: 0.25,
            objectFit: 'contain',
            bgcolor: 'background.paper',
            borderRadius: 1,
          }}
        />
      )}
      <Typography
        noWrap
        title={activeOrgName(me)}
        sx={{ fontWeight: 600, fontSize: '1.05rem', maxWidth: { md: 120, lg: 260 } }}
      >
        {activeOrgName(me)}
      </Typography>
    </Box>
  );
}
